import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { useSelector } from "react-redux";
import { getFieldOptions } from "../common/selectors";
import { dissoc } from "ramda";

const HidableGridItem = (props) => {
  const { fieldOption, children } = props;
  const fieldOptions = useSelector(getFieldOptions);

  const [showItem, setShowItem] = useState(true);
  useEffect(() => {
    if (fieldOptions[fieldOption]) {
      setShowItem(!fieldOptions[fieldOption].hidden);
    } else {
      setShowItem(true);
    }
  }, [fieldOptions, fieldOption]);

  const [gridProps, setGridProps] = useState({});
  useEffect(() => {
    setGridProps(dissoc("fieldOption", props));
  }, [props]);

  return (
    showItem && (
      <Grid item {...gridProps}>
        {children}
      </Grid>
    )
  );
};

export default HidableGridItem;
